export class BonusActions {
    static ActionStart: string = "BONUS_START";
    static ActionBack: string = "BONUS_BACK_TO_GAME";
    static ActionSpin: string = "BONUS_SPIN";
    static ActionSpinStop: string = "BONUS_SPIN_STOP";
    static ActionAutoplay: string = "BONUS_AUTOPLAY";
    static ActionAutoplayStop: string = "BONUS_AUTOPLAY_STOP";

    static ActionSkipWin: string = "BONUS_SKIP_WIN";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Actions/BonusActions.ts
 **/